import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonIcon } from '@morressier/alembic';
import { ISubmissionContext } from '@publishing-engine/domain/models';
import { useState } from 'react';
import EditJournalEmailsModal from './EditJournalEmailsModal';
import {
  getJournalAdditionalEmails,
  getJournalReplyToEmails
} from './journalEmailsConfig';

/**
 * The General tab's Journal Emails field. It edits a whole object rather than a
 * single value, so it brings its own modal instead of the shared single-value
 * one the other fields open.
 */
const JournalEmailsSection = ({ journal }: { journal: ISubmissionContext }) => {
  const [isOpen, setIsOpen] = useState(false);
  const replyToEmails = getJournalReplyToEmails(journal);
  const additionalEmails = getJournalAdditionalEmails(journal);

  return (
    <Flex direction="column" gap={2}>
      <Flex alignItems="center" gap={2}>
        <Text textStyle="headingItem">Journal Emails</Text>
        <Tooltip
          hasArrow
          placement="top"
          label="Edit emails"
          shouldWrapChildren
        >
          <ButtonIcon
            onClick={() => setIsOpen(true)}
            ariaLabel="edit-journalEmails"
            icon={<FontAwesomeIcon icon={faEdit} />}
          />
        </Tooltip>
      </Flex>
      {replyToEmails.length ? (
        <Text textStyle="textContext">
          Journal support: {replyToEmails.join(', ')}
        </Text>
      ) : null}
      {additionalEmails.length ? (
        <Text textStyle="textContext">
          Additional emails: {additionalEmails.join(', ')}
        </Text>
      ) : null}
      {isOpen ? (
        <EditJournalEmailsModal
          journal={journal}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </Flex>
  );
};

export default JournalEmailsSection;
